var _path, _path2, _path3, _circle, _circle2, _mask, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVulnerabilityIntelligenceLight = function SvgVulnerabilityIntelligenceLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67,
    height: 67,
    fill: "none",
    viewBox: "0 0 67 67"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    width: 39.572,
    height: 39.572,
    x: 2.515,
    y: 24.876
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#vulnerability-intelligence-light_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#vulnerability-intelligence-light_svg__b)",
    shapeRendering: "crispEdges"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vulnerability-intelligence-light_svg__c)",
    fillOpacity: 0.5,
    d: "M27.25 34.235a2 2 0 1 1 2.829 2.829L17.35 49.792a2 2 0 1 1-2.828-2.829z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vulnerability-intelligence-light_svg__d)",
    fillOpacity: 0.25,
    d: "M27.25 34.235a2 2 0 1 1 2.829 2.829L17.35 49.792a2 2 0 1 1-2.828-2.829z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M29.725 34.589a1.5 1.5 0 0 1 0 2.121L16.997 49.438a1.5 1.5 0 1 1-2.12-2.121l12.727-12.728a1.5 1.5 0 0 1 2.121 0Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 40.258,
    height: 40.258,
    x: -1.657,
    y: 28.19
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#vulnerability-intelligence-light_svg__e)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#vulnerability-intelligence-light_svg__f)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vulnerability-intelligence-light_svg__g)",
    d: "M19.522 38.964a4 4 0 1 1 5.657 5.657l-7.757 7.756a4 4 0 1 1-5.657-5.656z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    d: "M24.826 39.317a3.5 3.5 0 0 1 0 4.95l-7.757 7.757a3.5 3.5 0 0 1-4.95-4.95l7.757-7.757a3.5 3.5 0 0 1 4.95 0Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 54.856,
    height: 54.856,
    x: 12.036,
    y: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.3px)",
      clipPath: "url(#vulnerability-intelligence-light_svg__h)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.607,
    filter: "url(#vulnerability-intelligence-light_svg__i)",
    shapeRendering: "crispEdges"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.464,
    cy: 24.821,
    r: 17,
    fill: "url(#vulnerability-intelligence-light_svg__j)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 39.464,
    cy: 24.821,
    r: 17,
    fill: "url(#vulnerability-intelligence-light_svg__k)",
    style: {
      mixBlendMode: "screen"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.464,
    cy: 24.821,
    r: 16.5,
    stroke: "#fff",
    strokeOpacity: 0.25
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 41.187,
    height: 43.25,
    x: 18.87,
    y: 5.842
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#vulnerability-intelligence-light_svg__l)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#vulnerability-intelligence-light_svg__m)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "vulnerability-intelligence-light_svg__r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vulnerability-intelligence-light_svg__n"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vulnerability-intelligence-light_svg__o)",
    fillOpacity: 0.2,
    d: "M37.719 14.573c.833-.465 1.25-.698 1.461-.742.28-.058.286-.058.567 0 .211.044.628.277 1.46.742 1.422.794 3.508 1.606 6.121 1.881.734.077 1.101.116 1.36.265.226.131.414.327.536.558.14.264.158.554.196 1.132.335 5.101-1.135 13.416-9.115 17.194-.274.13-.411.195-.595.228a1.6 1.6 0 0 1-.493 0c-.184-.033-.321-.098-.595-.228-7.98-3.778-9.45-12.093-9.114-17.194.038-.578.057-.868.196-1.132a1.4 1.4 0 0 1 .536-.558c.259-.15.626-.188 1.36-.265 2.612-.275 4.698-1.087 6.119-1.88",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vulnerability-intelligence-light_svg__p)",
    d: "M37.719 14.573c.833-.465 1.25-.698 1.461-.742.28-.058.286-.058.567 0 .211.044.628.277 1.46.742 1.422.794 3.508 1.606 6.121 1.881.734.077 1.101.116 1.36.265.226.131.414.327.536.558.14.264.158.554.196 1.132.335 5.101-1.135 13.416-9.115 17.194-.274.13-.411.195-.595.228a1.6 1.6 0 0 1-.493 0c-.184-.033-.321-.098-.595-.228-7.98-3.778-9.45-12.093-9.114-17.194.038-.578.057-.868.196-1.132a1.4 1.4 0 0 1 .536-.558c.259-.15.626-.188 1.36-.265 2.612-.275 4.698-1.087 6.119-1.88",
    shapeRendering: "crispEdges",
    style: {
      mixBlendMode: "screen"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    d: "m29.704 17.277-.884-.467zm10.601 18.326-.428-.904zm-.595.228.176.984zm-1.088-.228-.428.904zm.595.228.176-.985zm9.47-19.112.501-.865zm.733 1.69-.998.066zm-.196-1.132-.884.467zm-9.477-3.446-.203.98zm-2.028.742-.488-.873zm1.461-.742-.202-.979zm2.028.742-.488.873c1.527.853 3.743 1.712 6.504 2.003l.104-.995.105-.995c-2.465-.259-4.423-1.024-5.737-1.759zm8.212 3.836-.998.066c.325 4.936-1.116 12.707-8.545 16.224l.428.904.428.904c8.531-4.039 10.031-12.897 9.685-18.163zM38.622 35.603l.428-.904c-7.429-3.517-8.87-11.288-8.545-16.224l-.997-.066-.998-.065c-.347 5.266 1.153 14.124 9.684 18.163zm-7.023-19.149.105.994c2.76-.29 4.976-1.149 6.503-2.002l-.488-.873-.488-.873c-1.314.735-3.271 1.5-5.736 1.76zm-2.091 1.955.997.066c.02-.306.032-.474.051-.6.016-.105.03-.128.032-.13l-.884-.468-.884-.467c-.262.495-.278 1.035-.31 1.534zm2.092-1.955-.105-.995c-.353.038-.669.07-.927.116a2.5 2.5 0 0 0-.829.279l.501.865.502.866c-.019.01.005-.011.173-.04.174-.031.408-.056.789-.097zm-1.896.823.884.467a.4.4 0 0 1 .153-.16l-.5-.865-.502-.865a2.4 2.4 0 0 0-.92.956zm10.601 18.326-.428-.904c-.147.07-.218.103-.275.126a.3.3 0 0 1-.068.021l.176.985.176.984c.34-.06.6-.192.847-.308zm-1.683 0-.428.904c.246.116.507.247.847.308l.176-.984.176-.985a.3.3 0 0 1-.069-.021 6 6 0 0 1-.274-.126zm1.088.228-.176-.985-.018.002a1 1 0 0 1-.105 0l-.018-.002-.176.985-.176.984c.26.047.585.047.845 0zm7.618-19.377-.104.995c.38.04.615.065.789.095.167.03.191.051.173.04l.501-.865.501-.865a2.5 2.5 0 0 0-.829-.28c-.258-.045-.573-.077-.926-.114zm2.092 1.955.998-.065c-.033-.5-.049-1.039-.31-1.534l-.884.467-.884.467c.001.003.015.026.031.131.02.126.031.294.051.6zm-.733-1.69-.5.866a.4.4 0 0 1 .153.16l.884-.468.884-.467a2.4 2.4 0 0 0-.92-.956zm-7.48-2.146.489-.873q-.616-.347-.991-.543c-.22-.114-.494-.251-.756-.305l-.202.98-.203.979c-.05-.01-.01-.01.24.12.217.114.513.28.936.515zm-3.488 0 .488.873c.422-.236.719-.401.937-.514.25-.13.289-.132.238-.121l-.202-.98-.202-.979c-.262.054-.537.19-.756.305-.252.13-.58.314-.99.543zm2.028-.742.202-.979c-.105-.022-.29-.064-.486-.064s-.38.042-.485.064l.202.98.202.979.127-.025c.012-.002-.01.002-.046.002s-.057-.004-.045-.002q.01 0 .042.007l.084.018z",
    mask: "url(#vulnerability-intelligence-light_svg__r)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vulnerability-intelligence-light_svg__c",
    x1: 23.176,
    x2: 14.523,
    y1: 41.139,
    y2: 49.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vulnerability-intelligence-light_svg__g",
    x1: 25.159,
    x2: 2.917,
    y1: 39.338,
    y2: 61.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vulnerability-intelligence-light_svg__j",
    x1: 39.464,
    x2: 39.464,
    y1: 22.909,
    y2: 41.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vulnerability-intelligence-light_svg__o",
    x1: 39.463,
    x2: 39.463,
    y1: 23.191,
    y2: 35.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vulnerability-intelligence-light_svg__a",
    transform: "translate(-2.515 -24.876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.25 34.235a2 2 0 1 1 2.829 2.829L17.35 49.792a2 2 0 1 1-2.828-2.829z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vulnerability-intelligence-light_svg__e",
    transform: "translate(1.657 -28.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.522 38.964a4 4 0 1 1 5.657 5.657l-7.757 7.756a4 4 0 1 1-5.657-5.656z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vulnerability-intelligence-light_svg__h",
    transform: "translate(-12.036)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.464,
    cy: 24.821,
    r: 17
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vulnerability-intelligence-light_svg__l",
    transform: "translate(-18.87 -5.842)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vulnerability-intelligence-light_svg__n"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vulnerability-intelligence-light_svg__b",
    width: 39.572,
    height: 39.572,
    x: 2.515,
    y: 24.876,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26360"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26360",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vulnerability-intelligence-light_svg__f",
    width: 40.258,
    height: 40.258,
    x: -1.657,
    y: 28.19,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26360"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26360",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vulnerability-intelligence-light_svg__i",
    width: 54.856,
    height: 54.856,
    x: 12.036,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.607
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.214
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26360"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26360",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vulnerability-intelligence-light_svg__m",
    width: 41.187,
    height: 43.25,
    x: 18.87,
    y: 5.842,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26360"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26360",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "vulnerability-intelligence-light_svg__d",
    width: 16,
    height: 2.909,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vulnerability-intelligence-light_svg__q",
    transform: "scale(.01563 .00284)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "vulnerability-intelligence-light_svg__k",
    width: 1.853,
    height: 1.853,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vulnerability-intelligence-light_svg__q",
    transform: "scale(.00181)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "vulnerability-intelligence-light_svg__p",
    width: 3.2,
    height: 2.901,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vulnerability-intelligence-light_svg__q",
    transform: "scale(.00312 .00283)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "vulnerability-intelligence-light_svg__n",
    d: "M37.719 14.573c.833-.465 1.25-.698 1.461-.742.28-.058.286-.058.567 0 .211.044.628.277 1.46.742 1.422.794 3.508 1.606 6.121 1.881.734.077 1.101.116 1.36.265.226.131.414.327.536.558.14.264.158.554.196 1.132.335 5.101-1.135 13.416-9.115 17.194-.274.13-.411.195-.595.228a1.6 1.6 0 0 1-.493 0c-.184-.033-.321-.098-.595-.228-7.98-3.778-9.45-12.093-9.114-17.194.038-.578.057-.868.196-1.132a1.4 1.4 0 0 1 .536-.558c.259-.15.626-.188 1.36-.265 2.612-.275 4.698-1.087 6.119-1.88"
  }))));
};
export default SvgVulnerabilityIntelligenceLight;